// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAW2BjYxprVs4vV5dz-dlOOQyswjXgN6XY",
    authDomain: "windresstarot.firebaseapp.com",
    databaseURL: "https://windresstarot.firebaseio.com",
    projectId: "windresstarot",
    storageBucket: "windresstarot.appspot.com",
    messagingSenderId: "831759077686",
    appId: "1:831759077686:web:e4c430ee5faae0538a2397",
    measurementId: "G-9ZP0GRP7BP"
  }
};

//  const MENU_SAVE_AS_PDF 100;


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
